import { Toaster as Sonner, type ToasterProps } from "sonner"

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      style={
        {
          "--normal-bg": "hsl(var(--card))",
          "--normal-text": "hsl(var(--card-foreground))",
          "--normal-border": "hsl(var(--border))",
        } as React.CSSProperties
      }
      toastOptions={{
        classNames: {
          toast: "!pr-9",
          closeButton:
            "!left-auto !right-2 !top-1/2 !bottom-auto !translate-x-0 !-translate-y-1/2 !rounded-md !bg-transparent !border-none !text-muted-foreground hover:!bg-muted hover:!text-foreground",
          success: "[&_[data-icon]]:text-emerald-600",
          error: "[&_[data-icon]]:text-red-600",
          warning: "[&_[data-icon]]:text-amber-600",
          info: "[&_[data-icon]]:text-blue-600",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
